<template>
  <div class="style-tag">
    {{ current.label }}
  </div>
</template>

<script>
export default {
  props: {
    current: Object,
    base: String,
  },
  computed: {
    currentId() {
      if (typeof this.current !== `undefined` && this.current.id) {
        return this.current.id;
      }
      return 1;
    },
    alias() {
      if (typeof this.current.alias !== `undefined`) {
        return this.current.alias;
      }
      return ``;
    },
  },
};
</script>

<style lang="scss">
.style-tag {
  color: #838383;
  position: relative;
  top: 2px;
}
</style>
